module.exports = __webpack_public_path__ + "img/placeholder.bac728e3.jpg";